import { Modal, notification } from 'antd'
import { clearAuthSession } from './auth'

let _modal = null
let _notification = null
let _insufficientBalanceHandler = null
let _vipRequiredHandler = null

export const setModalInstance = (m) => { _modal = m }
export const setNotificationInstance = (n) => { _notification = n }
export const setInsufficientBalanceHandler = (handler) => { _insufficientBalanceHandler = handler }
export const setVipRequiredHandler = (handler) => { _vipRequiredHandler = handler }

let handlingAuthError = false

const showLoginRequiredModal = (errMsg, defaultMsg) => {
    if (handlingAuthError) return
    handlingAuthError = true
    const instance = _modal || Modal
    instance.error({
        title: '登录已失效',
        content: errMsg || defaultMsg,
        okText: '重新登录',
        centered: true,
        onOk() {
            handlingAuthError = false
            clearAuthSession()
            window.location.href = '/login'
        },
    })
}

/**
 * 统一处理接口报错
 * - err_code 401/403：弹出 Modal，用户确认后清除 token 并跳转登录页
 * - err_code 8011：调用余额不足处理器（跳转到充值页）
 * - err_code 8012：调用会员开通处理器（弹出 VIP 购买弹窗）
 * - 其他错误：右上角 notification 提示
 */
export const handleApiError = (errCode, errMsg) => {
    if (errCode === 401) {
        showLoginRequiredModal(errMsg, '登录已过期，请重新登录')
    } else if (errCode === 403) {
        showLoginRequiredModal(errMsg, '账号已在其他设备登录，请重新登录')
    } else if (errCode === 8011) {
        if (_insufficientBalanceHandler) {
            _insufficientBalanceHandler(errMsg)
        } else {
            const n = _notification || notification
            n.error({
                message: '余额不足',
                description: errMsg || '您的额度已用完，请充值后继续使用',
                duration: 4,
                placement: 'topRight',
            })
        }
    } else if (errCode === 8012) {
        if (_vipRequiredHandler) {
            _vipRequiredHandler(errMsg)
        } else {
            const n = _notification || notification
            n.error({
                message: '需要开通会员',
                description: errMsg || '该功能需要开通会员后使用，请充值后继续使用',
                duration: 4,
                placement: 'topRight',
            })
        }
    } else {
        const n = _notification || notification
        n.error({
            message: '请求失败',
            description: errMsg || `服务异常（${errCode}），请稍后重试`,
            duration: 4,
            placement: 'topRight',
        })
    }
}

/**
 * 已被 errorHandler 处理过的错误，抛给调用方用于判断是否需要再展示提示
 */
export class ApiError extends Error {
    constructor(errCode, errMsg) {
        super(errMsg)
        this.errCode = errCode
        this.handled = true
    }
}
